module.exports = __webpack_public_path__ + "img/user-placeholder.7bc5f809.png";